import { isObjectTableFilter } from '@ipfabric/utils';
import type { SimpleFilterField } from 'components/Table/components/SimpleFilter/types/SimpleFilterField';

export const getChildFilterField = (
  filterField: SimpleFilterField,
): SimpleFilterField | null => {
  if (!filterField.child || !isObjectTableFilter(filterField.filter)) {
    return null;
  }

  const childFilter = filterField.filter.children.find(
    ({ field }) => field === filterField.child,
  );

  if (childFilter) {
    return {
      ...filterField,
      filter: childFilter.filter,
    };
  }

  return null;
};
